function Footer() {
  return (
    <>
    <div class='footer-container'>

      <div class='footer-item'>
        <p>ALLTIME HOME CARE SERVICES LLC</p>
        <ul>
          <li>Compassionate Care</li>
          <li>Personal Touch </li>
          <li>Peace of Mind </li>
        </ul>
      </div>

      <div class='separator'></div>

      <div class='footer-item'>
        <p>Executive Director: Lucy Tanui</p>
        <p>Phone: 816-799-6819</p>
        <p class='email-text'>Email: management@alltimehomecareservices.com</p>
        <p>Serving the Greater Kansas City Area</p>
      </div>

      <div class='separator'></div>

      <div class='footer-item'>
        <p>Scan the QR code below to save our contact info, mission & vision:</p>
        <img src='./images/contactqrcode.jpg' alt='QR Code' style={{width: '300px', height: '300px'}} />
      </div>

    </div>
    </>
  )
}

export default Footer